import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { tap } from 'rxjs/operators'
import { isAnonymous } from '../auth/auth.selectors'

@Injectable({ providedIn: 'root' })
export class AnonymousUserGuard {
  constructor(private store: Store, private router: Router) {}
  canActivate() {
    return this.store.pipe(
      isAnonymous,
      tap((res) => res || this.router.navigateByUrl('/'))
    )
  }
}
